<template>
  <div>
    <div class="app-container">
      <!-- 后退 -->
      <el-button
        :disabled="tableIndex===1"
        icon="el-icon-arrow-left"
        type="primary"
        plain
        @click="retreatFun"
      >
        后退
      </el-button>
      <!-- 前进 -->
      <el-button
        :disabled="forwardDisabled"
        type="primary"
        plain
        @click="forwardFun"
      >
        前进
        <i class="el-icon-arrow-right el-icon--right" />
      </el-button>
      <!-- 列表设置 -->
      <el-button
        icon="el-icon-setting"
        type="primary"
        plain
        @click="columnSetFun"
      >
        列表设置
      </el-button>
      <!-- 帮助 -->
      <el-button
        ref="helpDom"
        :disabled="!needHelp"
        icon="el-icon-help"
        type="primary"
        plain
        @click="helpFun"
      >
        帮助
      </el-button>

      <!-- 待办事项 -->
      <div
        v-if="showToDo"
        class="todo-list"
      >
        <el-badge
          v-for="todo in vTodoList"
          :key="todo.label"
          :value="todo.count"
          :hidden="todo.count === 0"
          :max="999"
          style="margin-right: 10px;"
        >
          <el-button @click="execute(todo.method)">
            {{ todo.label }}
          </el-button>
        </el-badge>
      </div>

      <!-- 列表设置弹窗 -->
      <el-dialog
        ref="transferDialog"
        title="列表设置"
        :visible.sync="dialogSetVisible"
        custom-class="transfer-dialog"
        :before-close="confirmSetFun"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
        @open="handleOpen('transferDialog')"
      >
        <el-row :gutter="10">
          <el-col :span="3">
            <div class="up_or_down">
              <el-button
                :disabled="leftChecked.length===0"
                type="primary"
                icon="el-icon-arrow-up"
                @click="toUp"
              />
              <el-button
                :disabled="leftChecked.length===0"
                type="primary"
                icon="el-icon-arrow-down"
                @click="toDown"
              />
            </div>
          </el-col>
          <el-col :span="9">
            <div class="left left-list-box">
              <h3 class="title">
                显示列
              </h3>
              <div class="limit-box">
                <ul>
                  <draggable
                    :list="leftData"
                    group="article"
                    class="dragArea"
                    @end="dragEnd"
                  >
                    <li
                      v-for="(item, index) in leftData"
                      :key="item.index"
                      :class="{active: item.isSelect }"
                      @click="leftCheckedFun(item, index)"
                    >
                      {{ item.label }}
                    </li>
                  </draggable>
                </ul>
              </div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="transfer-button">
              <el-button
                type="primary"
                icon="el-icon-arrow-right"
                :disabled="leftChecked.length===0"
                @click="toRightFun"
              />
              <el-button
                type="primary"
                icon="el-icon-d-arrow-right"
                @click="addAllToRightFun"
              />
              <el-button
                type="warning"
                icon="el-icon-arrow-left"
                :disabled="rightChecked.length===0"
                @click="toLeftFun"
              />
              <el-button
                type="warning"
                icon="el-icon-d-arrow-left"
                @click="deleteAllToLefFun"
              />
            </div>
          </el-col>
          <el-col :span="9">
            <div class="right left-list-box">
              <h3 class="title">
                隐藏列
              </h3>
              <div class="limit-box">
                <ul>
                  <li
                    v-for="(element, index) in rightData"
                    :key="element.index"
                    class="list-complete-item"
                    :class="{active: element.isSelect }"
                    @click="rightCheckedFun(element, index)"
                  >
                    {{ element.label }}
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
        </el-row>

        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="cancelSetFun">
            取消
          </el-button>
          <el-button
            type="primary"
            @click="confirmSetFun()"
          >
            确定
          </el-button>
        </div>
      </el-dialog>
    </div>
    <div
      v-if="showToDoDropdown"
      style="float:right;margin-top:5px;margin-right:10px"
    >
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          <span class="sp-icon el-icon--left"><i class="iconfont icon-todo" /></span><span
            v-if="todoDefault===1"
            class="sp-text"
          >{{ $t('button.todoDefault') }}</span><span
            v-else-if="todoDefault===2"
            class="sp-text"
          >{{ $t('button.overdue') }}</span><span class="sp-number">{{ todoTotal }}</span>
        </span>
        <el-dropdown-menu
          slot="dropdown"
          class="todo-box"
        >
          <el-dropdown-item
            v-if="todoDefault===1"
            class="clearfix"
          >
            {{ $t('button.todoText1') }}<span class="color-fd6154">{{ todoTotal }}</span>{{ $t('button.todoText2') }}{{ $t('button.todoDefault') }}
          </el-dropdown-item>
          <el-dropdown-item
            v-else-if="todoDefault===2"
            class="clearfix"
          />
          <el-dropdown-item
            v-for="(todo,index) in dropdownArr"
            :key="index"
            class="clearfix todo-item"
          >
            <div @click="execute(todo.method)">
              {{ todo.label }}
              <el-badge
                class="mark"
                :value="todo.count"
              />
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
// 弹窗拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
import { setTransferStatus, getListColumnName, setListColumnName, getToken } from '@/utils/auth'
import checkPermission from '@/utils/permission'
import draggable from 'vuedraggable'

export default {
  name: 'TableOperation',
  components: {
    draggable
  },
  mixins: [dialogDragMixin],
  props: {
    initTableColumn: {
      required: true,
      type: Array
    },
    tableColumns: {
      required: true,
      type: Array
    },
    tableKey: {
      required: true,
      type: String
    },
    tableIndex: {
      required: true,
      default: 0,
      type: Number
    },
    searchCondition: {
      required: true,
      type: Object
    },
    showToDo: {
      required: false,
      type: Boolean,
      default: false
    },
    todoList: {
      required: false,
      type: Array,
      default: () => {
        return []
      }
    },
    tableTransferName: {
      required: true,
      type: String
    },
    todoMark: {
      required: false,
      type: Number,
      default: 100
    },
    needHelp: {
      required: false,
      type: Boolean,
      default: false
    },
    showToDoDropdown: {
      required: false,
      type: Boolean,
      default: false
    },
    dropdownArr: {
      required: false,
      type: Array,
      default: () => {
        return []
      }
    },
    todoTotal: {
      required: false,
      type: Number,
      default: 0
    },
    specialStatus: {
      required: false,
      type: Boolean,
      default: false
    },
    actionFlag: {
      required: false,
      type: Boolean,
      default: false
    },
    actionName: {
      required: false,
      type: String,
      default: ''
    },
    infoFlag: {
      required: false,
      type: Boolean,
      default: false
    },
    infoName: {
      required: false,
      type: String,
      default: ''
    },
    todoDefault: {
      type: Number,
      default: 1
    }
  },
  data() {
    // eslint-disable-next-line no-unused-vars
    const generateData = (_) => {
      const data = []
      this.tableColumns.forEach((v) => {
        data.push({
          key: v.prop,
          label: v.label,
          isSelect: false
        })
      })
      return data
    }
    return {
      forwardDisabled: true,
      dialogSetVisible: false,
      leftData: generateData(),
      leftChecked: [],
      rightData: this.getListColumns(),
      rightChecked: [], // 选中隐藏列
      movedKeys: [],
      direction: '',
      themColor: this.$store.state.settings.theme,
      isDragEnd: false,
      isCompleted: false
    }
  },
  computed: {
    listColumn: {
      get() {
        return this.tableColumns
      },
      set(val) {
        this.$emit('update:tableColumns', val)
        setTransferStatus(this.tableTransferName, JSON.stringify(val))
      }
    },
    listIndex: {
      get() {
        return this.tableIndex
      },
      set(val) {
        this.$emit('update:tableIndex', val)
      }
    },
    queryCondition: {
      get() {
        return this.searchCondition
      },
      set(val) {
        this.$emit('update:searchCondition', val)
      }
    },
    vTodoList() {
      return this.todoList.filter((v) => (v.permissionSigns ? this.checkPermission(v.permissionSigns) : true))
    }
  },
  // 用于主列表列数据会变化
  watch: {
    initTableColumn(val) {
      let data = []
      val.forEach((v) => {
        if (!v.isLabel) {
          data.push({
            key: v.prop,
            label: this.$t(this.tableKey + '.' + v.prop)
          })
        } else {
          data.push({
            key: v.prop,
            label: v.label
          })
        }
      })
      this.transferValue = []
      this.transferData = data
    },
    dialogSetVisible(val) {
      if (val) {
        this.movedKeys = []
        this.direction = ''
        this.leftChecked = []
        this.rightChecked = []
        this.copySourceData()
        this.isCompleted = false
        this.isAllRight = false
        this.isOnceRight = false
        this.isAllLeft = false
        this.isOnceLeft = false
      }
    }
  },
  created() {
    let storageIndex = []
    for (let i = 0; i < sessionStorage.length; i++) {
      let storageKey = sessionStorage.key(i)
      if (storageKey && storageKey.indexOf(this.tableKey) > -1 && storageKey !== this.tableKey + '_0') {
        storageIndex.push(storageKey)
      }
    }
    storageIndex.forEach((v) => {
      sessionStorage.removeItem(v)
    })
  },
  methods: {
    retreatFun: function () {
      this.listIndex--
      let storageIndex = this.listIndex
      if (sessionStorage.getItem(this.tableKey + '_' + (storageIndex - 2))) {
        this.queryCondition = JSON.parse(sessionStorage.getItem(this.tableKey + '_' + (storageIndex - 2)))
      }
      this.forwardDisabled = false
      if (this.$parent.$refs.dialog) {
        // this.$parent.$parent.$refs[this.tableKey].$children[0].clearSort()
      } else {
        // this.$parent.$refs[this.tableKey].$children[0].clearSort()
      }
      this.$emit('reloadData')
    },
    forwardFun: function () {
      this.listIndex++
      let storageIndex = this.listIndex
      if (sessionStorage.getItem(this.tableKey + '_' + storageIndex)) {
        this.queryCondition = JSON.parse(sessionStorage.getItem(this.tableKey + '_' + storageIndex))
      }
      if (!sessionStorage.getItem(this.tableKey + '_' + (storageIndex + 1))) {
        this.forwardDisabled = true
      }
      if (this.$parent.$refs.dialog) {
        // this.$parent.$parent.$refs[this.tableKey].$children[0].clearSort()
      } else {
        // this.$parent.$refs[this.tableKey].$children[0].clearSort()
      }
      this.$emit('reloadData')
    },
    columnSetFun: function () {
      this.dialogSetVisible = true
    },
    getListColumns() {
      let ModuleName = ''
      if (this.todoMark === 100) {
        let name = this.tableKey + '_' + getToken()
        ModuleName = name + '_module'
      } else {
        ModuleName = `dialog_${this.tableKey}_${this.todoMark}_module`
      }
      let ListColumnsName = getListColumnName(ModuleName)
      if (ListColumnsName === '') {
        return []
      } else {
        return JSON.parse(ListColumnsName)
      }
    },
    setListColumns(val) {
      let ModuleName = ''
      if (this.todoMark === 100) {
        let name = this.tableKey + '_' + getToken()
        ModuleName = name + '_module'
      } else {
        ModuleName = `dialog_${this.tableKey}_${this.todoMark}_module`
      }
      setListColumnName(ModuleName, val)
    },
    cancelSetFun: function () {
      this.dialogSetVisible = false
      this.rightData = this.getListColumns()
      this.leftData = []
      this.tableColumns.forEach((v) => {
        this.leftData.push({
          key: v.prop,
          label: this.$t(this.tableKey + '.' + v.prop),
          isSelect: false
        })
      })
    },
    confirmSetFun: function () {
      this.dialogSetVisible = false
      let listColumnArr = []
      let leftNewArr = []
      this.leftData.forEach((item) => {
        leftNewArr.push(item.key)
      })
      if (this.direction === 'right' || this.direction === '') {
        listColumnArr = this.listColumn.filter((v) => this.movedKeys.indexOf(v.prop) < 0)
      } else if (this.direction === 'left') {
        let filterArray = this.initTableColumn.filter((v) => this.movedKeys.indexOf(v.prop) > -1)
        if (this.isAllRight) {
          listColumnArr = filterArray
        } else {
          listColumnArr = this.listColumn.concat(filterArray)
        }
      }
      this.isCompleted = true
      this.listColumn = listColumnArr.sort(this.sortFunc('prop', leftNewArr))
      this.leftData.forEach((item) => {
        item.isSelect = false
      })
      this.rightData.forEach((item) => {
        item.isSelect = false
      })
      this.setListColumns(JSON.stringify(this.rightData))
    },

    execute(method) {
      this.$emit(method)
    },
    // 帮助
    helpFun() {
      this.$emit('showHelp')
    },
    action() {
      this.$emit('actionFun')
    },

    // 对数据源进行复制
    copySourceData() {
      this.copyLeft = JSON.parse(JSON.stringify(this.leftData))
      this.copyRight = JSON.parse(JSON.stringify(this.rightData))
    },
    // 显示列选中事件
    leftCheckedFun(item) {
      item.isSelect = !item.isSelect
      if (item.isSelect) {
        this.leftChecked.push(item)
      } else {
        let fIndex = this.leftChecked.indexOf(item)
        this.leftChecked.splice(fIndex, 1)
      }
    },
    // 隐藏列选中事件
    rightCheckedFun(item) {
      item.isSelect = !item.isSelect
      if (item.isSelect) {
        this.rightChecked.push(item)
      } else {
        let fIndex = this.rightChecked.indexOf(item)
        this.rightChecked.splice(fIndex, 1)
      }
    },
    // 设置隐藏列
    toRightFun() {
      let isL = this.isAllLeft && this.isOnceLeft
      if (this.isCompleted || isL) {
        this.movedKeys = []
      }
      this.isOnceLeft = false
      if (!this.leftChecked) {
        this.$message.error(this.$t('validTips.addAgentEmpty'))
        return
      }
      this.leftChecked.forEach((item) => {
        this.movedKeys.push(item.key)
        let findIndex = this.leftData.indexOf(item)
        this.leftData.splice(findIndex, 1)
        item.isSelect = false
        this.rightData.push(item)
      })
      this.leftChecked = []
      this.direction = 'right'
    },
    // 列全部隐藏
    addAllToRightFun() {
      this.movedKeys = []
      this.leftData.forEach((item) => {
        this.movedKeys.push(item.key)
        item.isSelect = false
        if (!this.rightData.includes(item)) {
          this.rightData.push(item)
        }
      })
      this.direction = 'right'
      this.isAllRight = true
      this.isOnceRight = true
      this.leftData = []
      this.leftChecked = []
    },
    // 设置显示列
    toLeftFun() {
      let isR = this.isAllRight && this.isOnceRight
      if (this.isCompleted || isR) {
        this.movedKeys = []
      }
      this.isOnceRight = false
      if (!this.rightChecked) {
        this.$message.error(this.$t('validTips.addAgentEmpty'))
        return
      }
      this.rightChecked.forEach((item) => {
        this.movedKeys.push(item.key)
        let findIndex = this.rightData.indexOf(item)
        this.rightData.splice(findIndex, 1)
        item.isSelect = false
        this.leftData.push(item)
      })
      this.rightChecked = []
      this.direction = 'left'
    },
    // 列全部显示
    deleteAllToLefFun() {
      this.movedKeys = []
      this.AllRight = JSON.parse(JSON.stringify(this.rightData))
      this.rightData.forEach((item) => {
        this.movedKeys.push(item.key)
        item.isSelect = false
        if (!this.leftData.includes(item)) {
          this.leftData.push(item)
        }
      })
      this.direction = 'left'
      this.isAllLeft = true
      this.isOnceLeft = true
      this.rightData = []
      this.rightChecked = []
    },
    // 向上移
    toUp() {
      let isChecked = this.leftData.filter((item) => {
        return item.isSelect === true
      })
      if (isChecked.length > 1) {
        this.$message.error(this.$t('transfer_set.limit'))
        return
      }
      let fIndex = this.leftData.indexOf(isChecked[0])
      let tagVal = this.leftData[fIndex - 1]
      this.leftData[fIndex] = tagVal
      this.leftData[fIndex - 1] = isChecked[0]
      this.$forceUpdate()
    },
    // 向下移
    toDown() {
      let isChecked = this.leftData.filter((item) => {
        return item.isSelect === true
      })
      if (isChecked.length > 1) {
        this.$message.error(this.$t('transfer_set.limit'))
        return
      }
      let fIndex = this.leftData.indexOf(isChecked[0])
      let tagVal = this.leftData[fIndex + 1]
      this.leftData[fIndex] = tagVal
      this.leftData[fIndex + 1] = isChecked[0]
      this.$forceUpdate()
    },
    // columnSetFun () {
    //   this.dialogSetVisible = true
    // },
    // cancelSetFun () {
    //   this.dialogSetVisible = false
    //   this.leftData = this.copyLeft
    //   this.rightData = this.copyRight
    // },
    // confirmSetFun () {
    //   this.dialogSetVisible = false
    // },
    // 排序
    sortFunc(propName, referArr) {
      return (prev, next) => {
        return referArr.indexOf(prev[propName]) - referArr.indexOf(next[propName])
      }
    },
    // 拖动结束
    dragEnd() {
      this.isDragEnd = true
    },
    checkPermission
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/element-variables.scss';
@import '@/styles/variables.scss';
.app-container {
  padding: 0;
  padding-bottom: 10px;
}
.todo-list {
  vertical-align: middle;
  display: inline-block;
  .el-button {
    margin-left: 10px;
  }
}
:v-deep iconfont.icon_help {
  font-size: 14px;
}
::v-deep .el-icon--left.icon_help {
  margin-right: 0;
}
.el-dropdown-link {
  position: relative;
  padding: 4px 10px 4px 7px;
  border-radius: 3px;
  color: $light-blue;
  background: #ecf7ff;
  border: 1px solid $light-blue;
}
::v-deep .sp-icon {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 26px;
  background: $--color-primary;
  text-align: center;
}
.iconfont.icon-todo {
  color: #fff;
  line-height: 28px;
}
.sp-text {
  font-size: 12px;
  padding-left: 36px;
  color: $light-blue;
}
.sp-number {
  margin-left: 5px;
  background-color: #ff4949;
  border-radius: 10px;
  color: #ffffff;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
}
.el-dropdown-menu {
  width: 300px;
}
.todo-box {
  padding: 10px 15px 0;
  .todo-item {
    height: 32px;
    line-height: 32px;
    border-bottom: 1px solid #f0f3f8;
    color: #33363f;
    .el-badge {
      float: right;
      sup {
        vertical-align: middle;
      }
    }
  }
}
.el-dropdown-menu--mini .el-dropdown-menu__item {
  padding: 0;
}
.el-dropdown-link:hover {
  cursor: pointer;
}
.red {
  margin-left: 10px;
  font-size: 12px;
}
::v-deep .el-transfer__button {
  display: block !important;
  margin-left: 0 !important;
}

.left {
  width: 100%;
  border: 1px solid #d9dadc;
  float: left;
  background: #fff;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.right {
  width: 100%;
  border: 1px solid #d9dadc;
  float: left;
  background: #fff;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.left li,
.right li {
  padding: 0 10px;
}
.limit-box {
  overflow-x: hidden;
  overflow: auto;
  height: 250px;
}
.title {
  padding: 0;
  margin: 0;
  padding-left: 10px;
  border-bottom: 1px solid #d9dadc;
  height: 30px;
  line-height: 30px;
}
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
  line-height: 25px;
}
.transfer-button {
  padding-top: 50px;
}
.transfer-button .el-button {
  margin: 5px 10px;
  flex: 1;
}
.el-button {
  margin-left: 10px;
}
.right {
  width: 100%;
}
.right-list,
.list-complete-item {
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
  display: flex;
  overflow-x: hidden;
}
.right-list li,
.list-complete-item li {
  padding: 0 5px;
  margin: 0;
  line-height: 24px;
  border-bottom: 1px solid #e6ebf5;
  flex: 1;
}
li.order {
  flex: 0 1 60px;
  width: 60px;
  border-right: 1px solid #e6ebf5;
}
li.employee {
  border-right: 1px solid #e6ebf5;
  text-align: center;
}
.right-list > li {
  background: #efefef;
}
.li:hover {
  background: #b2e1ff;
}
.active {
  background: #7fceff;
}
.right-list-box {
  height: 255px;
  overflow-x: hidden;
  overflow: auto;
}
.tree-font {
  font-size: 12px;
}
::v-deep .el-tree-node__label {
  font-size: 12px;
}
span.prompt {
  font-size: 12px;
  color: red;
}
.sortable-chosen {
  background: #cee9fb;
}
.up_or_down {
  padding-top: 100px;
  .el-button {
    margin: 5px 10px;
  }
}
::v-deep .el-dialog__footer {
  padding: 10px !important;
}
</style>
